import React, { useEffect } from 'react';
import { useApplicationState } from 'hooks/applicationState-Context';
import AppDownloadPromo from 'shared/components/AppDownloadPromo/AppDownloadPromo';
import styles from './B2B2CBreakdown.module.scss'

const B2B2CBreakdownCoverScreen = () => {
  const { appState, setPageLoading } = useApplicationState();

  useEffect(() => setPageLoading(false), [])

  if (appState.isLoading) return null

  return (
    <div className={styles.container}>
      <AppDownloadPromo />
    </div>
  );
};

export default B2B2CBreakdownCoverScreen;
